import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _some from "lodash/some";
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { getSubProductType } from '@nerdwallet/marketplace/selectors/common';
import { BANKING_SUB_PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      _ref$marketplaceEntit = _ref.marketplaceEntitiesForCdApyTerms,
      marketplaceEntitiesForCdApyTerms = _ref$marketplaceEntit === void 0 ? {} : _ref$marketplaceEntit;
  var subProductType = getSubProductType(marketplaceEntity);
  var drivers;

  switch (subProductType) {
    case BANKING_SUB_PRODUCT_TYPES.CD:
      {
        /**
         * If no marketplaceEntitiesForCdApyTerms are supplied,
         * leverage APY supplied on the top, original marketplaceEntity
         */
        if (!_some(marketplaceEntitiesForCdApyTerms)) {
          drivers = [_objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntity)), {}, {
            description: null
          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactMinimumBalance(marketplaceEntity)), {}, {
            label: 'Minimum Deposit',
            description: null // Omit since Default description is redundant with CTA.

          })];
        } else {
          drivers = [_objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntitiesForCdApyTerms.oneYear)), {}, {
            id: 'apy1Year',
            label: '1-year APY',
            description: null // Omit since we are displaying multiple APY's.

          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntitiesForCdApyTerms.threeYear)), {}, {
            id: 'apy3Year',
            label: '3-year APY',
            description: null // Omit since we are displaying multiple APY's.

          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactAPY(marketplaceEntitiesForCdApyTerms.fiveYear)), {}, {
            id: 'apy5Year',
            label: '5-year APY',
            description: null // Omit since we are displaying multiple APY's.

          }), _objectSpread(_objectSpread({}, quickFactMappings.banking.getQuickFactMinimumBalance(marketplaceEntity)), {}, {
            label: 'Minimum Deposit',
            description: null // Omit since Default description is redundant with CTA.

          })];
        }

        break;
      }

    case BANKING_SUB_PRODUCT_TYPES.CASH_MANAGEMENT:
    case BANKING_SUB_PRODUCT_TYPES.CHECKING:
      drivers = [quickFactMappings.banking.getQuickFactMonthlyFee(marketplaceEntity), quickFactMappings.banking.getQuickFactAPY(marketplaceEntity), quickFactMappings.banking.getQuickFactBonus(marketplaceEntity)];
      break;

    case BANKING_SUB_PRODUCT_TYPES.MONEY_MARKET:
    case BANKING_SUB_PRODUCT_TYPES.SAVINGS:
      drivers = [quickFactMappings.banking.getQuickFactAPY(marketplaceEntity), quickFactMappings.banking.getQuickFactBonus(marketplaceEntity)];
      break;

    default:
      break;
  }

  return {
    drivers: drivers
  };
});